import { jsx as l, jsxs as m } from "react/jsx-runtime";
import "react";
var e = (a) => /* @__PURE__ */ m("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 80 80",
  ...a,
  children: [
    /* @__PURE__ */ l("mask", {
      id: "arrow-filled-mask",
      fill: "currentColor",
      children: /* @__PURE__ */ l("path", {
        fillRule: "evenodd",
        d: "M44.915 74.074a5.8 5.8 0 1 1-8.203-8.203l19.952-19.953-48.289-.495c-3.171-.032-5.768-2.63-5.8-5.8a5.602 5.602 0 0 1 5.682-5.684l49.914.512-22.175-22.175a5.683 5.683 0 1 1 8.037-8.037L75.29 35.496l.083.083a5.683 5.683 0 0 1 0 8.038l-.041.04-.042.043-30.375 30.374Z",
        clipRule: "evenodd"
      })
    }),
    /* @__PURE__ */ l("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M44.915 74.074a5.8 5.8 0 1 1-8.203-8.203l19.952-19.953-48.289-.495c-3.171-.032-5.768-2.63-5.8-5.8a5.602 5.602 0 0 1 5.682-5.684l49.914.512-22.175-22.175a5.683 5.683 0 1 1 8.037-8.037L75.29 35.496l.083.083a5.683 5.683 0 0 1 0 8.038l-.041.04-.042.043-30.375 30.374Z",
      clipRule: "evenodd"
    }),
    /* @__PURE__ */ l("path", {
      fill: "currentColor",
      d: "m44.915 74.074-.707-.707.707.707Zm-8.203-8.203-.707-.707.707.707Zm19.952-19.953.707.707 1.683-1.682-2.38-.025-.01 1Zm-48.289-.495-.01 1 .01-1Zm-5.8-5.8-1 .01 1-.01Zm5.682-5.684-.01 1 .01-1Zm49.914.512-.01 1 2.449.025-1.732-1.732-.707.707Zm17.202 9.166.704.71.003-.003-.707-.707Zm-.041.04-.704-.71-.007.007.71.703Zm-.042.043.707.707.004-.004-.711-.703ZM36.005 74.78a6.8 6.8 0 0 0 9.617 0l-1.414-1.414a4.8 4.8 0 0 1-6.79 0l-1.413 1.414Zm0-9.617a6.8 6.8 0 0 0 0 9.617l1.414-1.414a4.8 4.8 0 0 1 0-6.79l-1.414-1.413ZM55.957 45.21 36.005 65.164l1.414 1.414L57.37 46.625l-1.414-1.414Zm.718-.293-48.29-.495-.02 2 48.289.495.02-2Zm-48.29-.495c-2.627-.027-4.784-2.184-4.81-4.81l-2 .02c.037 3.715 3.074 6.752 6.79 6.79l.02-2Zm-4.81-4.81a4.602 4.602 0 0 1 4.672-4.674l.02-2a6.602 6.602 0 0 0-6.693 6.694l2-.02Zm4.672-4.674 49.913.512.02-2-49.912-.512-.021 2Zm27.042-21.956 22.175 22.175 1.414-1.414-22.175-22.175-1.414 1.414Zm0-9.451a6.683 6.683 0 0 0 0 9.451l1.414-1.414a4.683 4.683 0 0 1 0-6.623l-1.414-1.414Zm9.451 0a6.683 6.683 0 0 0-9.451 0l1.414 1.414a4.683 4.683 0 0 1 6.623 0l1.414-1.414Zm31.257 31.257L44.74 3.532l-1.414 1.414 31.257 31.257 1.414-1.414Zm.083.083-.083-.083-1.414 1.414.083.083 1.414-1.414Zm0 9.452a6.683 6.683 0 0 0 0-9.452l-1.414 1.414a4.683 4.683 0 0 1 0 6.623l1.414 1.415Zm-.045.044.042-.04-1.407-1.422-.042.04 1.407 1.422Zm-.034.035.041-.042-1.42-1.407-.043.042 1.422 1.407ZM45.622 74.781l30.375-30.374-1.414-1.414-30.375 30.374 1.414 1.414Z",
      mask: "url(#arrow-filled-mask)"
    })
  ]
});
export {
  e as default
};
